
$(document).ready(function () {
    $(".newsletter #newsletter_form").submit(function () {
        console.log("Going to submit newsletter contact form...");
        
        var $newsletter_field = $(this).find("#newsletter");
        var user_email_id = $.trim($newsletter_field.val());
        if(user_email_id == "") {
            return false;
        }
        
//        console.log("Subscribing for "+user_email_id);
//        return false;
        
        zaius.subscribe({
            list_id: ["newsletter"], 
            email: user_email_id //"lalmani@incipio.com"
        });
        
        $newsletter_field.hide();
        $(this).find(".sign-up-button").hide();
        
        $("#newsletter_success").html("You have successfully signed up!");
      
        gtag('event', 'conversion', {
          'send_to': 'AW-990852028/NuJwCPy9mvUBELznvNgD'
        });
        
        return false;
    });
  
  $('#email-capture').on('submit', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    var emailList = $(this).data('list');
    var emailInput = $(this).find('#email-notify');
    
    zaius.subscribe({
      list_id: [emailList], 
      email: emailInput.val()
    });
    
    emailInput.blur().val('');
    
    $('#email-notify-success').removeClass('hide');
    
    var timeOut = setTimeout(function() {
      $('#email-notify-success').addClass('hide');
      clearTimeout(timeOut);
    }, 10000);
  });
});